<template>
	<div id="app">
		<headmain v-if="$route.meta.hidehead!='hidehead'"></headmain>
		<router-view/>
		<footmain v-if="$route.meta.hidefoot!='hidefoot'"></footmain>
		<totop v-if="$route.meta.hidenav!='hidenav'"></totop>
	</div>
</template>

<script>
	import headmain from '@/components/headmain'
	import footmain from '@/components/footmain'
	import totop from '@/components/totop'
	export default {
		name: 'app',
		components: {
			headmain,
			footmain,
			totop,
		},
		data() {
			return {}
		},
		created() {
			this.windowResize();
			this.$nextTick(()=>{
				this.setScale();
			})
		},
		mounted(){
			$('title').text(window.config.VUE_TITLE)
		},
		methods: {
			windowResize() {
				var that = this;
				$(window).unbind('resize');
				$(window).bind('resize', function() {
					that.setScale()
				})
			},
			setScale() {
				var winWidth = $(window).width();
				var scale = 1;
				if(winWidth > 1250) {
					var scale = (winWidth / 1920).toFixed(2);
				} else {
					scale = 0.65;
				}
				$('body').css({
					"zoom": scale,
					"-moz-transform": "scale(" + scale + ")"
				});
				$('.minheight').css({
					"min-height": parseInt(800 / scale) + "px"
				});
			},
		}
	}
</script>